<template>
  <div class="topDiv">
    <div class="borderAndGround">
      <div class="space-btw">
        <span class="title">{{item.cpPositionName}}</span>
        <!-- <span class="money">{{item.cpMinSalary.replace('>','')}}-{{item.cpMaxSalary.replace('>','')}}</span> -->
      </div>
      <div class="space-btw">
        <div class="desc">
          <span class="other">经验{{item.cpJobYearsLabel}}</span>
          <span>|</span>
          <span class="other">{{item.cpEducationLabel}}学历</span>
        </div>
        <div class="desc">
          <template v-if="item.cpDamagedArea">
            <span class="ss" v-for="da in item.cpDamagedArea.split(',')">{{da}}</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:"JobViewIM",
  props:['item']
};
</script>
<style lang="stylus" scoped>
.space-btw{
  display flex;
  justify-content space-between;
  height 30px;
  color: gray;
}
.money {
  font-size: 14px;
  font-weight: 400;
  color: rgba(242, 20, 47, 1);
  margin-right 8px;
  line-height 21px;
}
.title {
  font-size: 14px;
  font-weight: 400;
  line-height 21px;
  color: #f82b18;
}
.desc{
  line-height 21px;
  span{
    margin-right 8px;
  }
}
.topDiv {
  width: 100%;
  text-align: left;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;

  ui, li {
    list-style: none;
    float: left;
    margin-left: 15px;
    font-size: 14px;
    color: #C2C2C2;
    font-weight: 400;
    line-height: 21px;

    span {
      margin-left: 5px;
    }
  }

  .ss {
    width: 60px;
    height: 20px;
    border: 1px solid #D7D7D7;
    padding: 3px;
    border-radius: 4px;
    margin-top: 0px;
    padding-top: 0px;
    font-size: 12px;
    text-align: center;
  }

  .borderAndGround {
    margin 0px 20px 0px 0px;
    padding 20px 20px;
    border-radius: 2px;
    border: 1px solid #f2f2f2;
    padding-bottom 15px;
    &:hover{
      cursor pointer;
      background: rgba(39, 201, 216, 0.1);
      border: 1px solid #f82b18;
    }
  }

  .btnMsg {
    width: 90px;
    height: 24px;
    padding: 0px 12px 0px 5px;
    line-height: 0px;
    border-radius: 9px;
    border: 1px solid #c2c2c2;
    background: #f82b18;
    font-size: 12px;
    font-weight: 400;
    color: white;
    line-height: 18px;
  }
}
</style>